import { render, staticRenderFns } from "./SmsSettings.vue?vue&type=template&id=438a04f0&scoped=true&"
import script from "./SmsSettings.vue?vue&type=script&lang=js&"
export * from "./SmsSettings.vue?vue&type=script&lang=js&"
import style0 from "./SmsSettings.vue?vue&type=style&index=0&id=438a04f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a04f0",
  null
  
)

export default component.exports